import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { CommonProvider } from '../common'
import { Response } from '../response'


@Injectable()
export class KnowledgeProvider {
    
    public apiUrl:string = null;
    public path:string = "api/v1/knowledge/";

    constructor(private http: HttpClient, public CommonService: CommonProvider) {

        this.apiUrl = CommonService.apiUrl;
    }

    listCategories(): Observable<Response<any>>
    {
        return this.http.get<Response<any>>(`${this.apiUrl}${this.path}listCategories`)
    }

    getPage(id): Observable<Response<any>>
    {
        return this.http.post<Response<any>>(`${this.apiUrl}${this.path}getPage`, {id})
    }

    getCompanyPage(): Observable<Response<any>>
    {
        return this.http.get<Response<any>>(`${this.apiUrl}${this.path}getCompanyPage`)
    }

}


// WEBPACK FOOTER //
// ./src/providers/knowledge/knowledge.ts